import { ElementState, Preview } from "@creatomate/preview";

const moveElementToTrack = async (
  targetTrack: number, preview: Preview, element?: ElementState, time?: number
) => {
  if (!preview.state || !element) return;

  const elementStartTime = element.localTime;
  const elementEndTime = elementStartTime + element.duration;

  // filter the elements from the target track
  const targetTrackElements = preview.state.elements.filter(
    (element: ElementState) => element.track === targetTrack);

  let updatedElement = { ...element, time };

  // filter the elements with a time that clashes with the current element
  const clashedTrackElements = targetTrackElements.filter((elm: ElementState) => {
    const filterStartTime = elm.globalTime;
    const filterEndTime = filterStartTime + elm.duration;

    if (filterStartTime > elementEndTime || filterEndTime < elementStartTime) {
      return false;
    }

    return true;
  });

  if (clashedTrackElements.length > 0) {
    const lastClashedElement = clashedTrackElements[clashedTrackElements.length - 1];
    updatedElement = {
      ...updatedElement,
      time: lastClashedElement.localTime + lastClashedElement.duration,
      duration: element.duration
    };
  }

  let modifications = {};

  // add the new element on it's new track
  modifications = {
    [`${updatedElement.source.id}.time`]: updatedElement.time,
    [`${updatedElement.source.id}.duration`]: updatedElement.duration,
    [`${updatedElement.source.id}.track`]: targetTrack < 1 ? 1 : targetTrack
  };

  if (targetTrack < 1) {
    preview.state.elements.forEach(elm => {
      if (elm.source.id !== updatedElement.source.id) {
        modifications = {
          ...modifications,
          [`${elm.source.id}.track`]: elm.track + 1
        };
      }
    });
  }

  await preview.applyModifications(modifications);
};

export default moveElementToTrack;
